// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconArrowRightLink = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9">
            <path
                fill="currentColor"
                d="M10.2796501,5.03027344 L6.52965009,8.78027344 C6.38433731,8.9279294 6.19215024,9.00058579 5.99996245,9.00058579 C5.80777466,9.00058579 5.61605608,8.92734361 5.46980631,8.78085923 C5.17683756,8.48789048 5.17683756,8.01328111 5.46980631,7.72031236 L7.94058716,5.25058579 L0.749962449,5.25058579 C0.335821867,5.25058579 0,4.91542983 0,4.50058579 C0,4.08574176 0.335821867,3.75058579 0.749962449,3.75058579 L7.94058716,3.75058579 L5.47027481,1.28027344 C5.17730606,0.987304688 5.17730606,0.512695312 5.47027481,0.219726562 C5.76324356,-0.0732421875 6.23785293,-0.0732421875 6.53082168,0.219726562 L10.2808217,3.96972656 C10.5726188,4.2638669 10.5726188,4.73730469 10.2796501,5.03027344 Z"
            />
        </svg>
    );
};

export default IconArrowRightLink;
